import React from "react";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <div className="container text-center mt-5">
      <h1 className="display-1 text-danger">404</h1>
      <p className="lead">الصفحة غير موجودة</p>
      <Link to="/" className="btn btn-primary">
        الرجوع إلى الصفحة الرئيسية
      </Link>
    </div>
  );
}

export default NotFound;
